<template>
  <div class="AboutWeb">
    <section-header heading="2" ja="プリクラONについて"/>
    <normal-btn @click="onAboutWeb02()">会員登録・ログインについて</normal-btn>
    <normal-btn @click="onAboutWeb10()">有料会員について</normal-btn>
    <normal-btn @click="onAboutWeb03()">X(旧Twitter)アカウントの注意点について</normal-btn>
    <normal-btn @click="onAboutWeb04()">会員登録メールについて</normal-btn>
    <normal-btn @click="onAboutWeb05()">プリクラONの専用サービスについて</normal-btn>
    <normal-btn @click="onAboutWeb06()">プリクラのダウンロードについて</normal-btn>
    <normal-btn @click="onAboutWeb07()">スマホへの保存について</normal-btn>
    <normal-btn @click="onAboutWeb08()">機種変更について</normal-btn>
    <normal-btn @click="onAboutWeb09()">アプリのアンインストール</normal-btn>
    <normal-btn @click="onAboutWeb01()">推奨環境について</normal-btn>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  mounted() {
    sessionStorage.setItem('prevPage', '/AboutWeb');
  },
  methods: {
    onHowToUse() {
      this.$router.push("/Tutorial")
    },
    onAboutWeb01() {
      this.$router.push("/AboutWeb01")
    },
    onAboutWeb02() {
      this.$router.push("/AboutWeb02")
    },
    onAboutWeb03() {
      this.$router.push("/AboutWeb03")
    },
    onAboutWeb04() {
      this.$router.push("/AboutWeb04")
    },
    onAboutWeb05() {
      this.$router.push("/AboutWeb05")
    },
    onAboutWeb06() {
      this.$router.push("/AboutWeb06")
    },
    onAboutWeb07() {
      this.$router.push("/AboutWeb07")
    },
    onAboutWeb08() {
      this.$router.push("/AboutWeb08")
    },
    onAboutWeb09() {
      this.$router.push("/AboutWeb09")
    },
    onAboutWeb10() {
      this.$router.push("/AboutWeb10")
    },
    onBack() {
      this.$router.push('/faq')
      // if(sessionStorage.getItem('prevPage')) {
      //   this.$router.push(sessionStorage.getItem('prevPage'))
      // } else {
      //   this.$router.push('/faq')
      // }
    }
  }
}
</script>

<style scoped>
</style>
